import { z } from 'zod';

const ANNOTATION_ID_PARAM_KEY = 'annotationId';
const PAGE_NUMBER_SEARCH_PARAM_KEY = 'page';

export type NeighborsParams = Record<typeof ANNOTATION_ID_PARAM_KEY, string>;

export const documentNeighborsRoute = () =>
  `/document/:${ANNOTATION_ID_PARAM_KEY}/neighbors` as const;

export const documentNeighborsPath = (
  annotationId: number,
  pageNumber: number
) =>
  `/document/${annotationId}/neighbors?${new URLSearchParams({
    [PAGE_NUMBER_SEARCH_PARAM_KEY]: String(pageNumber),
  }).toString()}`;

const neighborsParamsSchema = z.object({
  annotationId: z.coerce.number().int().positive(),
  pageNumber: z.coerce.number().int().positive(),
});

export const parseNeighborsParams = (params: NeighborsParams, search: string) =>
  neighborsParamsSchema.safeParse({
    annotationId: params[ANNOTATION_ID_PARAM_KEY],
    pageNumber:
      new URLSearchParams(search).get(PAGE_NUMBER_SEARCH_PARAM_KEY) ??
      undefined,
  });
